import { useQuery } from "@tanstack/react-query";
import {
	getCampaignBillets,
	getProductsHistory,
	getProductsHistoryPickers,
	type GetProductsHistoryParams,
	type GetProductsHistoryPickersParams,
} from "../repositories/ProductsHistoryRepository";

type UseProductsHistoryParams = Omit<GetProductsHistoryParams, "signal">;

export const useProductsHistory = ({
	start,
	end,
	crewId = null,
	productSizeId = null,
	productTypeId = null,
}: UseProductsHistoryParams) => {
	return useQuery({
		queryKey: [
			"productsHistory",
			start,
			end,
			crewId,
			productSizeId,
			productTypeId,
		],
		queryFn: ({ signal }) =>
			getProductsHistory({
				start,
				end,
				crewId,
				productSizeId,
				productTypeId,
				signal,
			}),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};

type UseProductsHistoryPickersParams = Omit<
	GetProductsHistoryPickersParams,
	"signal"
>;

export const useProductsHistoryPickers = ({
	start,
	end,
}: UseProductsHistoryPickersParams) => {
	return useQuery({
		queryKey: ["productsHistoryPickers", start, end],
		queryFn: ({ signal }) => getProductsHistoryPickers({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};

export const useCampaignBillets = ({
	campaignId,
}: {
	campaignId: number | null;
}) => {
	return useQuery({
		queryKey: ["campaignBillets", campaignId],
		queryFn: ({ signal }) =>
			getCampaignBillets({
				campaignId: campaignId as number,
				signal,
			}),
		enabled: campaignId != null,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
